import React, { ReactNode, useContext } from 'react';
import styled from 'styled-components';

import { ConnectedPointPosition, ConnectorsProviderContext, RegisteredElementType } from './ConnectorsProvider';

type ConnectorWrapperProps = {
  children: ReactNode;
  connectedPointPosition: ConnectedPointPosition;
  id: string;
  type: RegisteredElementType;
  meta: { moduleId: string } | null;
};

const ConnectorWrapper = ({ connectedPointPosition, id, children, type, meta }: ConnectorWrapperProps) => {
  const { registerElement, unregisterElement } = useContext(ConnectorsProviderContext);

  const handleRefChanged = (node: HTMLDivElement) => {
    if (node) {
      registerElement({ id, element: node, type, connectedPointPosition, meta });
    } else {
      unregisterElement(id);
    }
  };

  return <StyledWrapper ref={handleRefChanged}>{children}</StyledWrapper>;
};

const StyledWrapper = styled.div``;

export default ConnectorWrapper;
